import { render, staticRenderFns } from "./VerlibList.vue?vue&type=template&id=5a85d333&"
import script from "./VerlibList.vue?vue&type=script&lang=js&"
export * from "./VerlibList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports